import { NotificationRollset } from "@/pages/rollshop/models/RollshopNotification";
import { Box, Card, Chip, Stack, Typography, alpha } from "@mui/material";
import { RollInfo } from "./RollInfo";

type Props = {
	rollset: NotificationRollset;
};

export const RollsetCard = ({ rollset }: Props) => {
	const rollsetName = `${rollset.SectionName} ${rollset.StandName} ${rollset.RollsetLetter}`;

	const topSwapped =
		rollset.TopRollPrevPosition && rollset.TopRollPrevPosition !== "T";
	const bottomSwapped =
		rollset.BottomRollPrevPosition && rollset.BottomRollPrevPosition !== "B";

	const hasDiameterMismatch =
		rollset.TopRollDiameter != rollset.BottomRollDiameter;

	return (
		<Card
			elevation={0}
			sx={{
				backgroundColor: "background.paper",
				borderRadius: 2,
				border: hasDiameterMismatch
					? `1px solid #ef4444`
					: `1px solid ${alpha("#000", 0.08)}`,
				borderLeft: hasDiameterMismatch
					? `3px solid #ef4444`
					: `3px solid ${alpha("#000", 0.2)}`,
			}}
		>
			<Box sx={{ p: 2 }}>
				<Stack direction="row" alignItems="center">
					<Box width="30%">
						<Typography
							variant="body1"
							fontWeight={700}
							sx={{
								color: "text.primary",
								flexShrink: 0,
							}}
						>
							{rollsetName}
						</Typography>
						{hasDiameterMismatch ? (
							<Chip
								label={"Diameter Mismatch"}
								size="small"
								sx={{
									height: 16,
									fontSize: "0.6rem",
									backgroundColor: (theme) =>
										alpha(theme.palette.error.main, 0.15),
									color: (theme) => theme.palette.error.main,
									"& .MuiChip-label": { px: 0.75 },
								}}
							/>
						) : null}
					</Box>

					<Box sx={{ width: "35%", flexShrink: 0 }}>
						<RollInfo
							position="top"
							name={rollset.TopRollName}
							diameter={rollset.TopRollDiameter}
							wasSwapped={!!topSwapped}
						/>
					</Box>

					<Box sx={{ width: "35%", flexShrink: 0 }}>
						<RollInfo
							position="bottom"
							name={rollset.BottomRollName}
							diameter={rollset.BottomRollDiameter}
							wasSwapped={!!bottomSwapped}
						/>
					</Box>
				</Stack>
			</Box>
		</Card>
	);
};
